import './styles/App.scss';

import Form from './Form.js';
import Header from './Header.js';
import Head from './Head.js';


function App() {
  return (



    <>
    <Head/>
     <main>
  
      
      <Header/>
      <Form/>


     </main>
     

    </>
  );
}

export default App;
